import { css } from 'aphrodite';
import { Button } from '../../components/Button';
import { Button as ButtonV2 } from '../../components-v2/Button';
import { baseStyleSheet } from '../../styles/styles';
import { styleSheet } from './styles';
import { TestimonialCardCanvas } from './TestimonialCardCanvas';
import { TestimonialPreviewProps } from './types';

export const TestimonialPreview = ({
	isCreatingDraft,
	errorMessage,
	canvas,
	previewHtml,
	previewError,
	onCreateDraft,
	onTextOverflowChange,
	layout,
	visibleElements,
	selectedElement,
	onSelectElement,
	onLayoutBoxChange,
	reviewText,
	textColor,
	onReviewTextChange,
	canSaveDefaults,
	isSavingDefaults,
	onSaveDefaults,
}: TestimonialPreviewProps) => {
	const measureTextOverflow = (frameDocument: Document) => {
		const measureOnceTheWebfontSettles = () => {
			const quote = frameDocument.querySelector('.el.text');
			if (quote) {
				onTextOverflowChange(quote.scrollHeight > quote.clientHeight);
			}
		};

		if (frameDocument.fonts) {
			frameDocument.fonts.ready.then(measureOnceTheWebfontSettles);
		} else {
			measureOnceTheWebfontSettles();
		}
	};

	return (
		<div className={css(styleSheet.previewPane)}>
			<div className={css(styleSheet.contentContainer, styleSheet.previewContent)}>
				<h3 className={css(styleSheet.subtitle)}>Preview</h3>
				<span className={css(styleSheet.description)}>Review how your custom testimonial will look</span>

				<div className={css(styleSheet.previewWrapper)}>
					<TestimonialCardCanvas
						canvas={canvas}
						previewHtml={previewHtml}
						previewError={previewError}
						layout={layout}
						visibleElements={visibleElements}
						selectedElement={selectedElement}
						onSelectElement={onSelectElement}
						onLayoutBoxChange={onLayoutBoxChange}
						editableQuote={{ text: reviewText, color: textColor, onChange: onReviewTextChange }}
						onFrameReady={measureTextOverflow}
						fitToContainerHeight
					/>
				</div>

				{canSaveDefaults && (
					<div className={css(styleSheet.saveDefaultsRow)}>
						<ButtonV2
							variant='secondary'
							onClick={onSaveDefaults}
							isLoading={isSavingDefaults}
							disabled={isSavingDefaults || !layout}
						>
							Save as default
						</ButtonV2>
					</div>
				)}

				{errorMessage && (
					<div className={css(styleSheet.errorIndicator)}>
						<p className={css(styleSheet.errorMessage)}>{errorMessage}</p>
						<Button
							onClick={() => onCreateDraft(null)}
							className={css(baseStyleSheet.ctaButton)}
							disabled={isCreatingDraft}
						>
							Continue without Image
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};
